import {
  Armchair,
  BriefcaseBusiness,
  Building2,
  DraftingCompass,
  Hammer,
  HardHat,
  House,
  PaintRoller,
  Sofa,
  Trees,
  UserRound,
  UserRoundCog,
} from 'lucide-react';

const usageOptions = [
  { lines: ['Personal', 'Use'], Icon: UserRound },
  { lines: ['Professional', 'Use'], Icon: UserRoundCog },
  { lines: ['Business', 'Use'], Icon: BriefcaseBusiness },
];

const audienceItems = [
  { label: 'Homeowners', Icon: House },
  { label: 'Interior Designers', Icon: Armchair },
  { label: 'Architects', Icon: DraftingCompass },
  { label: 'Real Estate Professionals', Icon: Building2 },
  { label: 'Landscapers', Icon: Trees },
  { label: 'Home Builders', Icon: Hammer },
  { label: 'Home Improvement Professionals', Icon: PaintRoller },
  { label: 'Furniture Designers', Icon: Sofa },
  { label: 'Property Developers', Icon: HardHat },
];

function AudienceTrackGroup({ items, hidden = false }) {
  return (
    <div
      className="home-audience-track-group"
      {...(hidden ? { 'aria-hidden': true } : {})}
    >
      {items.map(({ label, Icon }) => (
        <div className="home-audience-item" key={label}>
          <Icon aria-hidden="true" strokeWidth={1.8} />
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}

function HomeAudienceSection() {
  return (
    <>
      <section className="home-usage-section" aria-label="Ways to use MyRoomsAI">
        <div className="home-usage-options">
          {usageOptions.map(({ lines, Icon }) => (
            <div className="home-usage-option" key={lines.join('-')}>
              <div className="home-usage-icon">
                <Icon aria-hidden="true" strokeWidth={1.8} />
              </div>
              <span className="home-usage-option__label">
                {lines[0]}
                <br />
                {lines[1]}
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="home-audience-strip" aria-label="Built for every home design user">
        <p className="sr-only">
          MyRoomsAI is designed for homeowners, interior designers, architects, real estate
          professionals, landscapers, home builders, home improvement professionals, furniture
          designers, and property developers.
        </p>
        <div className="home-audience-strip__viewport">
          <div className="home-audience-track">
            <AudienceTrackGroup items={audienceItems} />
            <AudienceTrackGroup items={audienceItems} hidden />
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeAudienceSection;
